import {gql, useMutation} from "@apollo/client";

const ADD_TEAM_TO_STAGE_MUTATION = gql`
mutation AddTeamToStage($stageId: Int!, $teamIds: [Int]!) {
  addTeamToStage(stageId: $stageId, teamIds: $teamIds) {
    success
  }
}
`;

export default function AddTeamToStageMutation() {
    return useMutation(ADD_TEAM_TO_STAGE_MUTATION);
}